import { useMemo } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components/Badge";
import { ScreeningStatus } from "shared/types";
import { screeningStatusTitle } from "./title";
import { cx } from "shared/utils";

export const ScreeningStatusBadge = ({
  status,
  className
}: {
  status?: string;
  className?: string;
}) => {
  const { variant, title } = useMemo(() => {
    switch (status) {
      case ScreeningStatus.Processing:
        return {
          variant: BadgeVariant.WARNING,
          title: screeningStatusTitle(status)
        };
      case ScreeningStatus.Completed:
        return {
          variant: BadgeVariant.SUCCESS,
          title: screeningStatusTitle(status)
        };
      case ScreeningStatus.Failed:
        return {
          variant: BadgeVariant.ERROR,
          title: screeningStatusTitle(status)
        };
      case ScreeningStatus.NotStarted:
      default:
        return {
          variant: BadgeVariant.BASE,
          title: screeningStatusTitle(status)
        };
    }
  }, [status]);

  return (
    <Badge
      className={cx("shrink-0 items-center", className)}
      variant={variant}
      size={BadgeSize.SM}
    >
      {title}
    </Badge>
  );
};
